<template>
  <div class="rent-number-continner">
    <div class="header-title">养号中心</div>
    <div class="sub-continner">
      <div class="person-card-content-second">
        <div
          id="all"
          class="item-second-content selected"
          @click="
            getRentNumber('全部');
            changeSeletorStyle($event);
          "
        >
          {{ rentNumberTotal || 0 }}
          <div>全部</div>
        </div>
        <div class="line-area"></div>
        <div
          id="ready"
          class="item-second-content"
          @click="
            getRentNumber('准备中');
            changeSeletorStyle($event);
          "
        >
          {{ readRentNumber }}
          <div>准备中</div>
        </div>
        <div class="line-area"></div>
        <div
          id="rennum"
          class="item-second-content"
          @click="
            getRentNumber('养号中');
            changeSeletorStyle($event);
          "
        >
          {{ processRentNumber }}
          <div>养号中</div>
        </div>
        <div class="line-area"></div>
        <div
          id="numfinish"
          class="item-second-content"
          @click="
            getRentNumber('养号完成');
            changeSeletorStyle($event);
          "
        >
          {{ finishRentNumber }}
          <div>养号完成</div>
        </div>
        <div class="line-area"></div>
        <div
          id="readyo"
          class="item-second-content"
          @click="
            getRentNumber('养号完成');
            changeSeletorStyle($event);
          "
        >
          {{ readyOrderRentNumber }}
          <div>可下单</div>
        </div>
      </div>
      <div class="main-card">
        <div class="main-card-content">
          提示：准备中的账号需要先养号才能去商城下单！
        </div>
      </div>

      <div class="main-list">
        <van-checkbox-group v-model="checkboxGroup" ref="checkboxGroup">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-cell
              v-for="(item, index) in showList"
              :key="item.rentNumbers || index"
              :title="item.title"
              :label="item.label"
              @click.stop="changeRentNumStatus(item)"
            >
              <template #title>
                <span
                  >租号：<span>{{ item.rentNumbers }}</span></span
                >
              </template>
              <template #default>
                <div
                  style="
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      align-items: center;
                    "
                >
                  <van-checkbox
                    v-if="item.status == 1"
                    :name="item"
                    @click.stop.native="() => {}"
                  ></van-checkbox>
                </div>
              </template>
              <template #label>
                状态：<span style="color: red">{{ item.rentStatus }}</span>
                <div v-if="item.status == 2">
                  <div style="display: inline-block">离完成:</div>
                  <div style="display: inline-block">
                    <van-count-down
                      :time="item.beginKeepRentNumberTimes * 60 * 1000"
                      format="DD 天 HH 时 mm 分 ss 秒"
                      @finish="finish"
                    />
                  </div>
                </div>
              </template>
            </van-cell>
          </van-list>
        </van-checkbox-group>
      </div>
      <div class="operation-bottom-area" v-show="isHaveRentReady">
        <div class="operation-item-one">
          <van-button @click="batchOpeChangeRentStatus">开始养号</van-button>
        </div>
        <div class="operation-item-two">
          <van-checkbox v-model="checked" @change="chooseAndProcess"
            >全选</van-checkbox
          >
        </div>
      </div>
    </div>
    <van-dialog
      v-model="isShowDialog"
      title="批量操作"
      show-cancel-button
      @confirm="dialogConfirm"
      style="text-align: center"
    >
      <van-field
        readonly
        clickable
        name="picker"
        :value="changeRentStatus"
        label="切换租号状态"
        @click="showDialogPicker = true"
      />
    </van-dialog>
    <van-popup v-model="showDialogPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConDialogfirm"
        @cancel="showDialogPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { MessageBox } from "mint-ui";
import {
  queryUserRentnumbers,
  changeRentNumberStatus,
  queryRentnumbersWithStatus,
} from "../../api/system/sys_plateform";
export default {
  name: "rentNumber",
  data() {
    return {
      queryForm: {
        rentStatus: 1,
        startTime: "",
        endTime: "",
      },
      minDate: new Date(2025, 0, 1),
      value: "",
      columns: ["全部", "准备中", "养号中", "养号完成", "商城下单", "已完成"],
      showPicker: false,
      isShowDialog: false,
      showDialogPicker: false,
      changeRentStatus: "",
      showCalendar: false,
      timeValue: "",
      refreshing: false,
      loading: false,
      finished: false,
      dataList: [],
      checkboxGroup: [],
      checked: false,
      // 展平为顶层属性，确保 Vue 2 响应式
      readRentNumber: 0,
      processRentNumber: 0,
      finishRentNumber: 0,
      readyOrderRentNumber: 0,
      rentNumberTotal: 0,
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: null,
      },
      requestSeq: 0,
    };
  },
  computed: {
    isHaveRentReady() {
      return this.dataList.some((item) => item.status == 1);
    },
    // 后端在查询时会把养号时长已到的记录自动提升为"养号完成"并返回，
    // 这里按当前选中的状态过滤，避免"养号中"列表里出现"养号完成"的数据
    showList() {
      let tmpStatus = null;
      switch (this.value) {
        case "准备中":
          tmpStatus = 1;
          break;
        case "养号中":
          tmpStatus = 2;
          break;
        case "养号完成":
          tmpStatus = 3;
          break;
        case "商城下单":
          tmpStatus = 4;
          break;
        case "已完成":
          tmpStatus = 5;
          break;
        default:
          tmpStatus = null;
      }
      if (tmpStatus == null) {
        return this.dataList;
      }
      return this.dataList.filter(
        (item) => Number(item.status) === tmpStatus
      );
    },
  },
  mounted() {
    this.$emit("titleChange", "养号");
    this.queryForm.rentStatus = null;
    this.loading = true;
    queryUserRentnumbers(this.queryForm, this.pagination)
      .then((res) => {
        if (res.success) {
          this.rentNumberTotal = res.data.total;
          // 保存首页数据到 dataList，避免丢失
          this.dataList = res.data.records;
          if (this.dataList.length >= res.data.total) {
            this.finished = true;
          }
        }
        this.fetchStatusCounts();
      })
      .catch((err) => {
        MessageBox({
          title: "提示",
          message: err.message,
          showCancelButton: true,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    batchOpeChangeRentStatus() {
      if (this.checkboxGroup.length > 0) {
        changeRentNumberStatus({
          rentNumberManages: this.checkboxGroup,
          rentStatus: 2,
        }).then((res) => {
          if (res.success) {
            setTimeout(() => {
              this.getData();
            }, 500);
            this.isShowDialog = false;
            this.checkboxGroup = [];
            this.checked = false;
          }
        });
      } else {
        Dialog.alert({
          title: "注意",
          message: "请选择要养的号码！",
        });
      }
    },
    chooseAndProcess() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
    },
    onConfirm(value) {
      this.value = value;
      this.changeRentStatus = value;
      this.showPicker = false;
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";
      this.getData();
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onCalConfirm(date) {
      let [start, end] = date;
      this.timeValue = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.showCalendar = false;
      this.queryForm.startTime = this.formatDate(start);
      this.queryForm.endTime = this.formatDate(end);
      this.getData();
    },
    onConDialogfirm(val) {
      this.changeRentStatus = val;
      this.showDialogPicker = false;
    },
    dialogConfirm() {
      let tmpStatus = 1;
      switch (this.changeRentStatus) {
        case "准备中":
          tmpStatus = 1;
          break;
        case "养号中":
          tmpStatus = 2;
          break;
        case "养号完成":
          tmpStatus = 3;
          break;
        case "商城下单":
          tmpStatus = 4;
          break;
        case "已完成":
          tmpStatus = 5;
          break;
        default:
          tmpStatus = null;
      }
      changeRentNumberStatus({
        rentNumberManages: this.dataList,
        rentStatus: tmpStatus,
      }).then((res) => {
        if (res.success) {
          setTimeout(() => {
            this.getData();
          }, 500);
          this.isShowDialog = false;
        }
      });
    },
    finish() {
      setTimeout(() => {
        this.getData();
      }, 500);
    },
    getData() {
      const seq = ++this.requestSeq;
      this.loading = true;
      this.pagination.pageNum = 1;
      this.finished = false;
      this.dataList = [];

      let tmpStatus = null;
      switch (this.value) {
        case "准备中":
          tmpStatus = 1;
          break;
        case "养号中":
          tmpStatus = 2;
          break;
        case "养号完成":
          tmpStatus = 3;
          break;
        case "商城下单":
          tmpStatus = 4;
          break;
        case "已完成":
          tmpStatus = 5;
          break;
        default:
          tmpStatus = null;
      }
      this.queryForm.rentStatus = tmpStatus;

      queryUserRentnumbers(this.queryForm, this.pagination)
        .then((res) => {
          if (seq !== this.requestSeq) return;
          if (res.success) {
            this.dataList = res.data.records;
          }
          // 列表查询结束后再查状态，确保后端数据已同步
          if (seq === this.requestSeq) {
            this.fetchStatusCounts();
          }
        })
        .catch((err) => {
          if (seq !== this.requestSeq) return;
          MessageBox({
            title: "提示",
            message: err.message,
            showCancelButton: true,
          });
        })
        .finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
    },
    fetchStatusCounts() {
      queryRentnumbersWithStatus().then((res) => {
        if (res.success && res.data) {
          const d = res.data;
          this.readRentNumber = Number(d.readRentNumber) || 0;
          this.processRentNumber = Number(d.processRentNumber) || 0;
          this.finishRentNumber = Number(d.finishRentNumber) || 0;
          this.readyOrderRentNumber = Number(d.readyOrderRentNumber) || 0;
        }
      });
    },
    changeSeletorStyle(e) {
      document
        .querySelectorAll(".item-second-content")
        .forEach((el) => el.classList.remove("selected"));
      e.currentTarget.classList.toggle("selected");
    },
    getRentNumber(status) {
      this.value = status;
      this.getData();
    },
    onLoad() {
      if (this.finished) return;

      this.pagination.pageNum = this.pagination.pageNum + 1;
      this.loading = true;

      let tmpStatus = 1;
      switch (this.value) {
        case "准备中":
          tmpStatus = 1;
          break;
        case "养号中":
          tmpStatus = 2;
          break;
        case "养号完成":
          tmpStatus = 3;
          break;
        case "商城下单":
          tmpStatus = 4;
          break;
        case "已完成":
          tmpStatus = 5;
          break;
        default:
          tmpStatus = null;
      }
      this.queryForm.rentStatus = tmpStatus;
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";

      const seq = ++this.requestSeq;
      queryUserRentnumbers(this.queryForm, this.pagination)
        .then((res) => {
          if (seq !== this.requestSeq) return;
          if (res.success) {
            if (res.data.records.length > 0) {
              this.dataList.push(...res.data.records);
            }
            if (this.dataList.length >= res.data.total) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          if (seq !== this.requestSeq) return;
          MessageBox({
            title: "提示",
            message: err.message,
            showCancelButton: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRefresh() {
      this.finished = false;
      if (!this.finished) {
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      this.loading = true;
      this.onLoad();
    },
    batchOperation() {
      this.isShowDialog = true;
    },
    changeRentNumStatus(rentNumber) {
      console.log(rentNumber);
    },
    getRentStatusWithStatus(status) {
      if (status > 1 || status < 5) {
        console.log("status值错误");
      }
      switch (status) {
        case 1:
          return "准备中";
        case 2:
          return "养号中";
        case 3:
          return "养号完成";
        case 4:
          return "商城下单";
        case 5:
          return "已完成";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../root.scss";

.rent-number-continner {
  background-color: rgb(249, 249, 249);
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  bottom: calc(50px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
}

.sub-continner {
  flex: 1;
  min-height: 0;
  margin-top: 10;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-title,
.person-card-content-second,
.main-card {
  flex-shrink: 0;
}

.main-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.item-second-content {
  color: #ffffff;
}

::v-deep .van-count-down {
  color: red;
  font-size: calculeResultFontSize(false, 0px);
  line-height: 18px;
  padding-left: 2px;
}
.van-cell span {
  font-size: calculeResultFontSize(false, 2px) !important;
}

.selected {
  color: #f55033;
}
</style>
